<template>
    <div class="business-stage BusinessStage.vue yellowjob">

      <div class="content">
        <a href="javascript:;" class="go-back" @click="goBack()">
          <arrowBack></arrowBack>
        </a>

        <h1 class="title-primary animated fadeInDown delay1000ms">
          Queremos te conhecer um pouco melhor, <span class="sub"> {{ guestName }}!</span>
        </h1>
        <!-- /.title-primary -->
        <div class="choice-list animated fadeInDown delay1000ms">
          <div class="form-check" v-for="item in stageList">
            <div class="checkbox">
              <label class="form-check-label">
                <input v-model="businessState" class="form-check-input" type="radio" name="businessState" v-bind:value="item">
                <span></span>
                {{ item }}
              </label>
            </div>
          </div>
          <div class="clearfix"></div>
          <!-- /.clearfix -->
        </div>
        <!-- /.choice-list -->
      </div>
      <!-- /.content -->
    </div>

</template>

<script>
  import logo from '../../assets/logo.svg'
  import arrowBack from '../arrowBack.vue'

  export default {
    name: 'BusinessStage',
    data() {
      return {
        stageList:[
          'Estou começando um novo negócio/projeto.',
          'Gostaria de um orçamento para minha empresa'
        ]
      }
    },
    computed: {
      guestName() {
        return this.$store.getters.guestFirstName;
      },
      businessState: {
        get() {
          return this.$store.state.client.businessState;
        },
        set(value) {
          this.$store.commit('setBusinessStage', value);
        }
      }
    },
    watch:{
      guestType(val){
        if (val === 'candidate'){
          this.$router.push('candidate');
        }else if(val === 'client'){
          this.$router.push('/client/overview');
        }
      },
      businessState(val){
        if (val){
          // this.$router.push('/client/cart')
          this.$router.push('/client/contact')
        }
      }
    },
    mounted() {
      this.log('mounted: ' + this.$options.name);

      if(this.businessState !== ''){
        this.$store.commit('setBusinessStage', '');
      }

      // seta a classe do menu principal
      this.$store.commit('setMenuClass', 'inverted');

      if (!this.$store.state.guestName) {
        console.log('making fake guest...');
        this.$store.commit('setGuestName', '');
      }

      setTimeout(()=>{
        window.scrollTo(0,0);
      }, 1000);
    },
    methods: {
      goBack() {
       this.$router.go(-1);
        // this.$router.push('/client/overview');
      }
    },
    components: {
      arrowBack,
      logo
    },
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/client/BusinessStage.vue